<template>
  <el-dialog
    title="Vehicle Form"
    :visible="visible"
    top="10vh"
    @opened="handleDialogOpened"
    @close="handleDialogClose"
    destroy-on-close
  >
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-form-item label="Plate" prop="plate">
        <el-input v-model="form.plate" disabled></el-input>
      </el-form-item>
      <el-form-item label="EDI Name" prop="edi_name">
        <el-input v-model="form.edi_name"></el-input>
      </el-form-item>
      <el-form-item label="Make" prop="make">
        <el-input v-model="form.make"></el-input>
      </el-form-item>
      <el-form-item label="Model" prop="model">
        <el-input v-model="form.model"></el-input>
      </el-form-item>
      <el-form-item label="Sub Model" prop="sub_model">
        <el-input v-model="form.sub_model"></el-input>
      </el-form-item>
      <el-form-item label="Basic Colour" prop="basic_colour">
        <el-input v-model="form.basic_colour"></el-input>
      </el-form-item>
      <el-form-item label="Second Colour" prop="second_colour">
        <el-input v-model="form.second_colour"></el-input>
      </el-form-item>
      <el-form-item label="Tare Weight (tonne)" prop="tare_weight">
        <el-input
          v-model.number="form.tare_weight"
          placeholder="Tare Weight unit: tonne"
        ></el-input>
      </el-form-item>
      <el-form-item label="GVM (tonne)" prop="gross_vehicle_weight">
        <el-input
          v-model.number="form.gross_vehicle_weight"
          placeholder="GVM unit: tonne"
        ></el-input>
      </el-form-item>
      <el-form-item label="Power (kw)" prop="power">
        <el-input
          v-model.number="form.power"
          placeholder="Engine Power unit: kw"
        ></el-input>
      </el-form-item>
      <el-form-item label="Type" prop="type">
        <el-select
          v-model="form.type"
          placeholder="Please select a type"
          clearable
        >
          <el-option
            v-for="types in vehicleTypes"
            :label="types.label"
            :key="types.key"
            :value="types.key"
          >
            <span>{{ types.label }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Body Style" prop="body_style">
        <el-select
          v-model="form.body_style"
          placeholder="Please select a body style"
          clearable
        >
          <el-option
            v-for="style in vehicleBodyStyles"
            :label="style.label"
            :key="style.key"
            :value="style.key"
          >
            <span>{{ style.label }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Special Equipment(s)" prop="special_equipments">
        <el-select
          v-model="form.special_equipments"
          placeholder="Please select special equipment(s)"
          clearable
          multiple
        >
          <el-option
            v-for="equipment in vehicleSpecialEquipments"
            :label="equipment.label"
            :key="equipment.key"
            :value="equipment.key"
          >
            <span>{{ equipment.label }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <!--Footer Buttons-->
      <el-form-item>
        <el-button type="primary" @click="handleClickSubmit">Save</el-button>
        <el-button @click="handleClickReset">Reset</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "VehicleForm",
  data() {
    return {
      rules: {
        plate: [
          { required: true, message: "Please enter a plate", trigger: "blur" },
        ],
        power: [
          { type: "number", message: "Please enter a number", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    ...mapActions("vehicles", ["closeForm", "updateVehicle"]),
    handleClickSubmit() {
      console.log("submit!");
      this.updateVehicle(this.form);
    },
    handleClickReset() {
      console.log("reset!");
    },
    handleDialogOpened() {
      console.log("handleDialogOpened");
      this.$refs["form"].clearValidate();
    },
    handleDialogClose() {
      console.log("handleDialogClose");
      this.closeForm();
    },
  },
  computed: {
    ...mapState({
      visible: (state) => state.vehicles.formVisible,
      form: (state) => state.vehicles.form,
      vehicleTypes: (state) => state.vehicles.vehicleTypes,
      vehicleBodyStyles: (state) => state.vehicles.vehicleBodyStyles,
      vehicleSpecialEquipments: (state) =>
        state.vehicles.vehicleSpecialEquipments,
    }),
  },
};
</script>

<style scoped>
</style>